// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"7":"0c20c1c674b96b07","316":"83f2bbcd93d01219","317":"971e03dc20660bfa","501":"d13bf505216111a2","756":"aab1dded6ccca12e","839":"852c6c7e965ce7ee","930":"581e59f1b5c1fa39","959":"8313194bde14b9cd"}[chunkId] + ".js";
};